export default "__VITE_ASSET__D9yvdDI8__"